export default {"src":"/_next/static/media/SAR.7bdb9aa1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};